function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:none;stroke:#636363;}\r\n\t.st1{fill:#636363;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1"
}, React.createElement("g", {
  id: "_x32_.3.2a-SA_x5F_cntnt_x5F_rpo_x5F_MASTER-COVER",
  transform: "translate(-755.000000, -146.000000)"
}, React.createElement("g", {
  id: "noun_Gear_2434677",
  transform: "translate(755.000000, 146.000000)"
}, React.createElement("g", {
  id: "Group-8"
}, React.createElement("g", {
  id: "secondary-button"
}, React.createElement("path", {
  id: "Rectangle-Copy-4",
  className: "st0",
  d: "M4.5,0.5h31c2.2,0,4,1.8,4,4v31c0,2.2-1.8,4-4,4h-31c-2.2,0-4-1.8-4-4v-31 C0.5,2.3,2.3,0.5,4.5,0.5z"
}))))));

var _ref5 = /*#__PURE__*/React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M26.8,12.9h-13c-0.2,0-0.3,0.2-0.2,0.4l4.8,7.6c0.2,0.3,0.3,0.7,0.3,1.2v6.6c0,0.2,0.2,0.4,0.3,0.3l2.7-1.2 c0.1,0,0.1-0.1,0.1-0.2v-5.5c0-0.4,0.1-0.8,0.3-1.2l4.8-7.6C27.1,13.2,27,12.9,26.8,12.9z"
})));

const SvgFilter = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter.2fd858b5.svg";
export { ForwardRef as ReactComponent };